import * as _ from "lodash";
export function checkFeature({
  featureName,
  company,
  planDetails,
  callback,
  showUpgradeModal,
  recordsToAdd = 1
}) {
  try {
    // console.log({ featureName, planDetails, usage: company.usageDetails, recordsToAdd });
    const feature = _.find(_.get(planDetails, "features", []), {
      name: featureName
    });
    const planName = _.get(planDetails, "name", "");
    const displayName = _.get(planDetails, "displayName", "");
    const usageDetails = _.get(company, "usageDetails", {});
    const upgradeMessage =
      planName === "free" ? "Upgrade your plan " : "Upgrade your plan";
    let visible = !feature.allowed;
    let content = null;
    let title = `Upgrade to Premium to access ${feature.displayName}`;
    let limitToCheck = 0;
    if (feature) {
      switch (featureName) {
        case "roles_permissions":
          title = visible ? ` Custom Roles is a premium feature` : "";
          content =
            "Keep your workspace secure and compliant by creating custom roles to assign permissions to your team members.";

          break;
        case "customfields":
          title = visible
            ? ` Unlock ultimate flexibility with Custom Fields`
            : "";
          content =
            "Upgrade to the Premium Plan or try it now to tailor your test cases and runs with custom data, ensuring precise and efficient QA management. ";

          break;
        case "savedFilters":
          title = visible
            ? ` Unlock Speed and Precision with Saved Filters!`
            : "";
          content =
            "Say goodbye to repetitive filtering tasks and hello to instant efficiency. Apply multiple filters with just one click, saving valuable time and boosting your productivity.";

          break;
        case "reusableSteps":
          title = visible ? ` Save countless hours with Reusable Steps! ` : "";
          content =
            "Upgrade to Premium or try it now and eliminate tedious, repetitive typing by reusing frequently used test case steps, allowing your team to focus on critical tasks.";

          break;
        case "defects":
          title = visible ? ` Unlock the power of Defect Management` : "";
          content =
            "Upgrade to Premium to post bugs automatically from Test Collab to Jira, say goodbye to hassle of switching between multiple apps!";

          break;
        case "tags":
          title = visible
            ? ` Experience the ultimate organization with Tags! `
            : "";
          content =
            "Upgrade to Premium or try it now to categorize and filter test cases with ease, dramatically enhancing workflow efficiency.";
          break;
        // case "inbuiltRequirement":
        //   title = visible
        //     ? `Your current plan doesn't have this feature. Please purchase this addon or contact us`
        //     : "";
        //   content =
        //     "This feature is available in selected plans only. Please purchase this addon or contact us! ";
        //   break;
        case "configurations":
        case "executedTemplates":
        case "taskReview":
        case "testCaseVersioning":
          title = visible ? `Unlock the power of test case versions` : "";
          content =
            "Upgrade to Premium to use same test suites among multiple projects, when you make any changes in source project, all changes are automatically done in all other projects! ";

          break;
        case "csvExport":
          title = visible ? `Unlock the power of Export` : "";
          content =
            "Upgrade to Premium to export test cases on the basis of different available options";

          break;
        case "suiteLinking":
          title = visible ? `Boost Efficiency with Reusable Suites` : "";
          content =
            "Upgrade to the Premium plan or try it now to share test suites across multiple projects seamlessly. Any changes made in the source project will automatically reflect in all other projects! ";

          break;
        case "multiFilter":
          title = visible ? `Unlock the power of Advanced Filters` : "";
          content =
            "Upgrade to Premium to use advanced filters, it also allows multiple filters on same field";
          break;
        case "requirements":
          title = visible ? `Unlock the power of Requirement mapping` : "";
          content =
            "Upgrade to Premium to link your Jira user stories to your test cases! ";

          break;
        case "dataExportSQL":
          title = visible ? `Easily backup your data` : "";
          content =
            "Create a SQL backup of your data with just one click. Upgrade to TestCollab Enterprise to unlock data export and more.";
          break;
        case "okta":
        case "OKTA":
        case "SSO":
          title = visible
            ? "Secure user access through seamless integration with OKTA"
            : "";
          content =
            "Using OKTA SSO, users can access TestCollab securely and instantly. Upgrade to TestCollab Enterprise to unlock SSO and more.";
          break;
        case "auditLog":
          title = visible ? "Ensure compliance with granular audit logs" : "";
          content =
            "Detect security breaches, manage risks and gain insights with detailed audit logs. Upgrade to TestCollab Enterprise to unlock audit log and more.";
          break;
        case "passwordPolicies":
          title = visible
            ? "Secure your data by enforcing password policies"
            : "";
          content =
            "To prevent security breaches, create password policies for your team. Upgrade to TestCollab Enterprise to unlock password policies and more.";
          break;
        case "2FA":
        case "sessionManagement":
        case "hipaa":
        case "tailoredOnboarding":
        case "liveChat":
          title = visible
            ? `Your current plan doesn't have this feature. Please purchase this addon or contact us`
            : "";
          content =
            "This feature is available in selected plans only. Please purchase this addon or contact us! ";
          break;

        case "qaCopilot":
          title = visible ? `Revolutionize Testing with QA Copilot!` : "";
          content =
            "Simplify your testing process with AI by converting plain English into executable test scripts. No programming skills needed—execute hundreds of test cases with a single click, saving hours of manual work and reducing errors.";

          break;
        case "API":
          title = `Your current plan does not allow API token generation!`;
          break;
        case "users":
          const exestingUsers = _.get(usageDetails, featureName, 1);
          limitToCheck = exestingUsers + recordsToAdd;
          let userLimit =
            planName === "free"
              ? feature.limit
              : _.get(company, "paymentProfile.users", feature.limit);

          // alert("CHECKING FOR " + limitToCheck + " ALLOWED IS " + userLimit);
          if (limitToCheck && userLimit) {
            if (userLimit < limitToCheck) {
              title = `Your current plan allows ${userLimit} team members. ${upgradeMessage} to add more team members`;
              visible = true;
            }
          }
          break;
        case "projects":
        case "testCases":
        case "executedCases":
          const records = _.get(usageDetails, featureName, 0);
          limitToCheck = records + recordsToAdd;
          // alert("CHECKING FOR " + limitToCheck + " ALLOWED IS " + feature.limit);
          if (records) {
            if (feature.limit < limitToCheck) {
              title = `Limit exhausted for ${
                feature.displayName
              }, ${upgradeMessage} `;
              visible = true;
            }
          }
          break;
        case "testDataSets":
          title = visible
            ? `Your current plan doesn't have this feature. Please purchase this addon or contact us`
            : "";
          content =
            "This feature is available in selected plans only. Please purchase this addon or contact us! ";
          break;
        case "callToTest":
        case "automaticDefectStatusUpdate":
        case "customReports":
        case "customDashboard":
        case "issueManager":
        case "jira":
        case "kaatlonPlugin":
        case "exploratoryTesting":
        case "inbuilt":
          title = visible
            ? `Transform Your Workflow with the Integrated Issue Management Module!`
            : "";
          content =
            "Upgrade to Elite Plan to post bugs automatically in Test Collab, say goodbye to hassle of switching between multiple apps!";
          break;
        case "slack":
          title = visible
            ? `Stay updated on your test runs and test cases with instant Slack notifications!`
            : "";
          content =
            "Upgrade to the Elite Plan or try it now to get real-time alerts and updates directly in Slack, ensuring you never miss a critical update.";
          break;
        case "inbuiltRequirement":
          title = visible
            ? `Transform Your Workflow with the Integrated Requirement Management Module!
            `
            : "";
          content =
            "Upgrade to Elite Plan to Capture, analyze, and manage project requirements in a breeze and enhance team collaboration efficiently with TestCollab's requirement manager.";
          break;

        case "testCaseApproval":
          title = visible
            ? `Unleash the Potential of the test case review and approval process`
            : "";
          content =
            "Upgrade to the Elite Plan and eliminate bottlenecks in test case review and approvals. Enhance your team's workflow, ensure superior quality control and compliance, and boost communication for a more effective testing process.";
          break;
        case "testAutomation":
          title = visible ? `Unlock the power of Automation` : "";
          content =
            "Upgrade to Premium to automate execution/run of test plans";
        default:
          break;
      }

      showUpgradeModal({ visible, title, content, feature: featureName });
      return callback(!visible);
    }
    return callback(true);
  } catch (error) {
    console.log({ error });
    return callback(true);
  }
}

export function linFeatureWrapper({}) {}

export function isAllowedFeature({ featureName, planDetails }) {
  const feature = _.find(_.get(planDetails, "features", []), {
    name: featureName
  });
  return _.get(feature, "allowed", false);
}
